import { DateTime } from 'luxon';

const LEGACY_TO_IANA = {
  yerevan_utc4: 'Asia/Yerevan',
  london_utc0: 'Europe/London',
  newyork_utc5: 'America/New_York',
  losangeles_utc8: 'America/Los_Angeles',
  tokyo_utc9: 'Asia/Tokyo',
  sydney_utc10: 'Australia/Sydney',
  moscow_utc3: 'Europe/Moscow',
  berlin_utc1: 'Europe/Berlin',
  paris_utc1: 'Europe/Paris',
  rome_utc1: 'Europe/Rome',
  madrid_utc1: 'Europe/Madrid',
  amsterdam_utc1: 'Europe/Amsterdam',
  zurich_utc1: 'Europe/Zurich',
  vienna_utc1: 'Europe/Vienna',
  prague_utc1: 'Europe/Prague',
  warsaw_utc1: 'Europe/Warsaw',
  stockholm_utc1: 'Europe/Stockholm',
  copenhagen_utc1: 'Europe/Copenhagen',
  oslo_utc1: 'Europe/Oslo',
  helsinki_utc2: 'Europe/Helsinki',
  athens_utc2: 'Europe/Athens',
  bucharest_utc2: 'Europe/Bucharest',
  sofia_utc2: 'Europe/Sofia',
  kiev_utc2: 'Europe/Kiev',
  istanbul_utc3: 'Europe/Istanbul',
  dubai_utc4: 'Asia/Dubai',
  tehran_utc330: 'Asia/Tehran',
  karachi_utc5: 'Asia/Karachi',
  mumbai_utc530: 'Asia/Kolkata',
  dhaka_utc6: 'Asia/Dhaka',
  bangkok_utc7: 'Asia/Bangkok',
  jakarta_utc7: 'Asia/Jakarta',
  singapore_utc8: 'Asia/Singapore',
  hongkong_utc8: 'Asia/Hong_Kong',
  shanghai_utc8: 'Asia/Shanghai',
  beijing_utc8: 'Asia/Shanghai',
  seoul_utc9: 'Asia/Seoul',
  melbourne_utc10: 'Australia/Melbourne',
  auckland_utc12: 'Pacific/Auckland',
  honolulu_utc10: 'Pacific/Honolulu',
  anchorage_utc9: 'America/Anchorage',
  denver_utc7: 'America/Denver',
  chicago_utc6: 'America/Chicago',
  toronto_utc5: 'America/Toronto',
  mexicocity_utc6: 'America/Mexico_City',
  saopaulo_utc3: 'America/Sao_Paulo',
  buenosaires_utc3: 'America/Argentina/Buenos_Aires',
  lima_utc5: 'America/Lima',
  caracas_utc4: 'America/Caracas',
  bogota_utc5: 'America/Bogota',
  santiago_utc4: 'America/Santiago',
  reykjavik_utc0: 'Atlantic/Reykjavik',
  casablanca_utc0: 'Africa/Casablanca',
  cairo_utc2: 'Africa/Cairo',
  nairobi_utc3: 'Africa/Nairobi',
  johannesburg_utc2: 'Africa/Johannesburg',
  lagos_utc1: 'Africa/Lagos',
  accra_utc0: 'Africa/Accra',
  dakar_utc0: 'Africa/Dakar',
  abidjan_utc0: 'Africa/Abidjan',
  bamako_utc0: 'Africa/Bamako',
  ouagadougou_utc0: 'Africa/Ouagadougou',
  niamey_utc1: 'Africa/Niamey',
  ndjamena_utc1: 'Africa/Ndjamena',
  khartoum_utc2: 'Africa/Khartoum',
  addisababa_utc3: 'Africa/Addis_Ababa',
  kampala_utc3: 'Africa/Kampala',
  daressalaam_utc3: 'Africa/Dar_es_Salaam',
  antananarivo_utc3: 'Indian/Antananarivo',
  portlouis_utc4: 'Indian/Mauritius',
  victoria_utc4: 'Indian/Mahe',
  muscat_utc4: 'Asia/Muscat',
  kuwaitcity_utc3: 'Asia/Kuwait',
  riyadh_utc3: 'Asia/Riyadh',
  doha_utc3: 'Asia/Qatar',
  manama_utc3: 'Asia/Bahrain',
  abudhabi_utc4: 'Asia/Dubai',
  kabul_utc430: 'Asia/Kabul',
  tashkent_utc5: 'Asia/Tashkent',
  almaty_utc6: 'Asia/Almaty',
  bishkek_utc6: 'Asia/Bishkek',
  dushanbe_utc5: 'Asia/Dushanbe',
  ashgabat_utc5: 'Asia/Ashgabat',
  ulaanbaatar_utc8: 'Asia/Ulaanbaatar',
  pyongyang_utc9: 'Asia/Pyongyang',
  vladivostok_utc10: 'Asia/Vladivostok',
  magadan_utc11: 'Asia/Magadan',
  kamchatka_utc12: 'Asia/Kamchatka',
  chukotka_utc12: 'Asia/Anadyr',
  anadyr_utc12: 'Asia/Anadyr',
  petropavlovsk_utc12: 'Asia/Kamchatka',
  yuzhnosakhalinsk_utc11: 'Asia/Sakhalin',
  khabarovsk_utc10: 'Asia/Vladivostok',
  yakutsk_utc9: 'Asia/Yakutsk',
  irkutsk_utc8: 'Asia/Irkutsk',
  krasnoyarsk_utc7: 'Asia/Krasnoyarsk',
  omsk_utc6: 'Asia/Omsk',
  novosibirsk_utc7: 'Asia/Novosibirsk',
  barnaul_utc7: 'Asia/Barnaul',
  tomsk_utc7: 'Asia/Tomsk',
  kemerovo_utc7: 'Asia/Novosibirsk',
  novokuznetsk_utc7: 'Asia/Novosibirsk',
  abakan_utc7: 'Asia/Krasnoyarsk',
  kyzyl_utc7: 'Asia/Krasnoyarsk',
  gornoaltaysk_utc7: 'Asia/Barnaul',
  birobidzhan_utc10: 'Asia/Vladivostok',
  blagoveshchensk_utc9: 'Asia/Yakutsk',
  chita_utc9: 'Asia/Chita',
  ulanude_utc8: 'Asia/Irkutsk',
};

export function normalizeTimezone(tz) {
  if (!tz) return null;
  if (tz.includes('/') || tz.startsWith('UTC') || tz === 'local') return tz;
  return LEGACY_TO_IANA[tz.toLowerCase()] || null;
}

export function formatDate_D_MMM(dateLike, zone) {
  const tz = normalizeTimezone(zone);
  const dt = DateTime.fromJSDate(new Date(dateLike), { zone: tz || 'local' });
  if (!dt.isValid) return '—';
  return dt.toFormat('d LLL');
}

export function convertTimeRange({ date, from, to }, sourceZone, targetZone) {
  const src = normalizeTimezone(sourceZone) || 'local';
  const dst = normalizeTimezone(targetZone) || 'local';

  if (!date || !from) return '—';

  const dateStr = typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
    ? date
    : DateTime.fromJSDate(new Date(date), { zone: src }).toFormat('yyyy-LL-dd');

  const fromNorm = from.length <= 5 ? `${from}:00` : from;
  const toNorm = to ? (to.length <= 5 ? `${to}:00` : to) : null;

  const start = DateTime.fromISO(`${dateStr}T${fromNorm}`, { zone: src });
  const end = toNorm
    ? DateTime.fromISO(`${dateStr}T${toNorm}`, { zone: src })
    : start.plus({ hours: 1 });

  if (!start.isValid || !end.isValid) return '—';

  const startInDst = start.setZone(dst);
  const endInDst = end.setZone(dst);

  if (!startInDst.isValid || !endInDst.isValid) return '—';

  return `${startInDst.toFormat('HH:mm')} - ${endInDst.toFormat('HH:mm')}`;
}

export function lessonStatusFromZones({ date, from, to }, sourceZone) {
  const src = normalizeTimezone(sourceZone) || 'local';
  if (!date || !from) return 'upcoming';

  const dateStr = typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
    ? date
    : DateTime.fromJSDate(new Date(date), { zone: src }).toFormat('yyyy-LL-dd');

  const fromNorm = from.length <= 5 ? `${from}:00` : from;
  const toNorm = to ? (to.length <= 5 ? `${to}:00` : to) : null;

  const start = DateTime.fromISO(`${dateStr}T${fromNorm}`, { zone: src });
  const end = toNorm
    ? DateTime.fromISO(`${dateStr}T${toNorm}`, { zone: src })
    : start.plus({ hours: 1 });

  if (!start.isValid || !end.isValid) return 'upcoming';

  const now = DateTime.now().setZone(src);
  if (now < start) return 'upcoming';
  if (now <= end) return 'in-progress';
  return 'completed';
}
